import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { Client } from "src/db/Client"
import { getAuth0 } from "src/utils/auth0Utils"
import { toCamelCase } from "src/utils/data-transform"

const BASE_URL = import.meta.env.VITE_MBLS_DELIVERY_BE_URL

export const appApi = createApi({
  reducerPath: "appApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: async (headers) => {
      headers.set("Content-Type", "application/json")
      headers.set("ts", Date.now().toString())
      try {
        const auth0 = getAuth0()
        const token = await auth0.getAccessTokenSilently({
          authorizationParams: {
            audience: "mbls-global-api",
          },
        })

        if (token) {
          headers.set("Authorization", `Bearer ${token}`)
          headers.set("ts", `${Date.now()}`)
        }
      } catch (error) {
        console.error("Error fetching Auth0 token:", error)
      }
      return headers
    },
  }),
  tagTypes: ["Client"],
  endpoints: (builder) => ({
    getClients: builder.query<{ data: Client[] }, void>({
      query: () => "/clients",
      transformResponse: (response) => toCamelCase(response),
      providesTags: (result) =>
        result
          ? [
              ...result?.data?.map(({ id }) => ({
                type: "Client" as const,
                id,
              })),
              { type: "Client", id: "LIST" },
            ]
          : [{ type: "Client", id: "LIST" }],
    }),
  }),
})

export const { useGetClientsQuery } = appApi
